import * as React from "react";
import { GridItem, Link, Text } from "@chakra-ui/react";
import { Checkbox, Form, Grid, PasswordInputs, TextInput } from "components";
import { useCompleteRegistration, getValidation } from "./duck";

const CompleteRegistration: React.FC = () => {
  const onSubmit = useCompleteRegistration();
  const [agreementChecked, setAgreementChecked] = React.useState(false);

  return (
    <Form {...getValidation()} width="21.25rem" onSubmit={onSubmit}>
      {({ setValue }) => (
        <Grid templateColumns="1fr">
          <PasswordInputs />
          <GridItem>
            <TextInput
              type="password"
              numeric
              name="pin"
              label="PIN"
              placeholder="PIN"
            />
          </GridItem>

          <GridItem>
            <Checkbox
              label={
                <Text as="span">
                  I agree to the{" "}
                  <Link
                    isExternal
                    fontStyle="italic"
                    textDecoration="underline"
                    href="https://scoutapp.vet/policy.html"
                  >
                    Privacy Policy
                  </Link>{" "}
                  and{" "}
                  <Link
                    isExternal
                    fontStyle="italic"
                    textDecoration="underline"
                    href="https://scoutapp.vet/terms.html"
                  >
                    Terms and Conditions
                  </Link>
                </Text>
              }
              labelProps={{ textAlign: "justify" }}
              name="agreement"
              onChange={e => {
                setValue("agreement", e.target.checked);
                setAgreementChecked(e.target.checked);
              }}
            />

            <Form.Controls
              submitText="Set Password"
              w="full"
              submitProps={{ w: "full", isDisabled: !agreementChecked }}
            />
          </GridItem>
        </Grid>
      )}
    </Form>
  );
};

export default CompleteRegistration;
